<template>
  <div class="table-page-search-wrapper">
    <a-form layout="inline">
      <a-form layout="inline">
        <a-row :gutter="48"> <a-col :md="6" :sm="24">
          <a-form-item label="名称">
            <a-input placeholder="请输入名称" v-model="searchModel.userName"/>
          </a-form-item>
        </a-col><a-col :md="6" :sm="24">
          <a-form-item label="编号">
            <a-input placeholder="请输入编号" v-model="searchModel.userNumber"/>
          </a-form-item>
        </a-col><a-col :md="6" :sm="24">
          <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
            <a-button type="primary" @click="search">查询</a-button>
            <a-button style="margin-left: 8px" @click="clearSearch">重置</a-button>
          </span>
        </a-col>
        </a-row>
      </a-form>
    </a-form>
  </div>
</template>

<script>

export default {
  name: 'GroupSearchForm',
  mounted () {

  },
  data () {
    return {

      searchModel: {
        userName: '',
        userNumber: ''
      },
      advanced: false// 是否展开
    }
  },
  methods: {
    // 搜索框展开
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 点击查询按钮
    search () {
      this.searchModel.userName = this.searchModel.userName.trim()
      this.searchModel.userNumber = this.searchModel.userNumber.trim()
      this.$emit('setSearchCondition', this.searchModel)
    },
    // 点击复位按钮
    clearSearch () {
      this.searchModel.userName = ''
      this.searchModel.userNumber = ''

      this.$emit('clearSearch', this.searchModel)
    }
    // 获取select列表

  }
}
</script>

<style scoped>

</style>
